import React from 'react';
import { Form, Col } from 'react-bootstrap';
import { Selectize, FormSelect } from '~/components/FormControl';
import { REVEALED_PHASE_OPTIONS } from '~/config/constants';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import isEmpty from 'lodash/isEmpty';

function ConditionSuccessFailureDetail() {
    const { cardMetaData } = useFormTab();

    const { effects, conditions, prompts } = cardMetaData;
    return (
        <>
            {!isEmpty(cardMetaData) && (
                <>
                    <Form.Row className="justify-content-between">
                        <Selectize
                            as={Col}
                            sm={5}
                            name="conditionSuccessFailureDetail.condition1SuccessEffects"
                            options={[...effects, ...conditions, ...prompts] || []}
                            tooltip="Effects to run if player fulfils the first condition."
                        />
                        <Selectize
                            as={Col}
                            sm={5}
                            name="conditionSuccessFailureDetail.condition1FailureEffects"
                            options={[...effects, ...conditions, ...prompts] || []}
                            tooltip="Effects to run if player fails the first condition."
                        />
                    </Form.Row>
                    <Form.Row className="justify-content-between">
                        <Selectize
                            as={Col}
                            sm={5}
                            name="conditionSuccessFailureDetail.condition2SuccessEffects"
                            options={[...effects, ...conditions, ...prompts] || []}
                            tooltip="Effects to run if player fulfils the second condition."
                        />
                        <Selectize
                            as={Col}
                            sm={5}
                            name="conditionSuccessFailureDetail.condition2FailureEffects"
                            options={[...effects, ...conditions, ...prompts] || []}
                            tooltip="Effects to run if player fails the second condition."
                        />
                    </Form.Row>
                    <Form.Row className="justify-content-between">
                        <Selectize
                            as={Col}
                            sm={5}
                            name="conditionSuccessFailureDetail.condition3SuccessEffects"
                            options={[...effects, ...conditions, ...prompts] || []}
                            tooltip="Effects to run if player fulfils the third condition."
                        />
                        <Selectize
                            as={Col}
                            sm={5}
                            name="conditionSuccessFailureDetail.condition3FailureEffects"
                            options={[...effects, ...conditions, ...prompts] || []}
                            tooltip="Effects to run if player fails the third condition."
                        />
                    </Form.Row>
                    <Form.Row className="justify-content-between">
                        <FormSelect
                            name="conditionSuccessFailureDetail.conditionRevealedPhaseOption"
                            options={REVEALED_PHASE_OPTIONS || []}
                            sm={5}
                            tooltip="Effects to run only when it is revealed in a selected phase. If empty, it will run on all phases."
                        />
                    </Form.Row>
                </>
            )}
        </>
    );
}

export default ConditionSuccessFailureDetail;
